import { QuestionDetails } from "../Models/applicationModels";

export const mapAnswersToOptions = (rowValue: QuestionDetails): (string | null)[] => {
    return rowValue.answer.map(ans =>
        ans ? rowValue.questionOptions.find(opt => opt.toLowerCase() === ans.toLowerCase()) || ans : ans
    );
};

export const processSelectOptions = (options: string[], capitalizeFn: (str: string) => string) => {
    return options.map((option: string) => ({
        value: option,
        label: capitalizeFn(option)
    }));
};
